
import './App.css';
import { About } from './Components/About/About';
import { Contact } from './Components/Contact/Contact';
import { Footer } from './Components/Footer/Footer';
import { Header } from './Components/Header/Header';
import { Navbar } from './Components/NavBar/Navbar';
import { Project } from './Components/Projects/Project';
import { Skills } from './Components/Skills/Skills';

function App() {
  return (
 <>
 <Navbar/>
    <Header/>
    <About/>
    <Skills/>
    <Project/>
    <Contact/>
    <Footer/>
 </>
  );
}

export default App;
